import React from 'react'
import { Link } from 'react-router-dom'
import CloudyLogo from '../CloudyLogo'

export default function LandingFooter() {
  return (
    <footer className="landing-footer">
      <div className="landing-footer__logo">
        <CloudyLogo size={28} theme="dark" />
        Cloudy Pocket
      </div>

      <div className="landing-footer__links">
        <a href="#features" onClick={(e) => { e.preventDefault(); document.querySelector('#features')?.scrollIntoView({ behavior: 'smooth' }) }}>
          Fonctionnalités
        </a>
        <a href="#security" onClick={(e) => { e.preventDefault(); document.querySelector('#security')?.scrollIntoView({ behavior: 'smooth' }) }}>
          Sécurité
        </a>
        <a href="#pricing" onClick={(e) => { e.preventDefault(); document.querySelector('#pricing')?.scrollIntoView({ behavior: 'smooth' }) }}>
          Tarifs
        </a>
        <Link to="/contact">Contact</Link>
        <Link to="/legal">Mentions légales</Link>
      </div>

      <div className="landing-footer__copy">
        © {new Date().getFullYear()} CloudyPocket — Tous droits réservés.
      </div>
    </footer>
  )
}
